import React from 'react'
import styled from 'styled-components'
import globals from '@pods-finance/globals'
import { Button, Modal as Base } from '@pods-finance/components'

import { modals } from '../../../../constants'
import { ReactComponent as AssetLogo } from '../../../../assets/logo/logo_gradient.svg'

const Modal = styled(Base)`
  & > div[data-component='card'] {
    max-width: 500px;
    border-radius: ${props => props.theme.sizes.edge};
  }
`

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: calc(${props => props.theme.sizes.edge} * 1);
`

const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin-top: calc(${props => props.theme.sizes.edge} * 1);
  margin-bottom: calc(${props => props.theme.sizes.edge} * 1);
  padding-top: calc(${props => props.theme.sizes.edge} * 2);
  padding-bottom: calc(${props => props.theme.sizes.edge} * 2);

  border-top: 1px solid ${props => props.theme.colors.grayBlueLight};
  border-bottom: 1px solid ${props => props.theme.colors.grayBlueLight};
`

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: calc(${props => props.theme.sizes.edge} * 1);
  &:last-child {
    margin-bottom: 0;
  }
`

const Title = styled.div`
  width: 100%;
  text-align: center;
  & > p {
    color: ${props => props.theme.colors.dark};
    font-size: 13pt;
    font-weight: 600;
    line-height: 1.5;
    margin: 0 0 10px 0;
  }
`

const Description = styled.div`
  width: 100%;
  text-align: center;
`

const Paragraph = styled.p`
  color: ${props => props.theme.colors.dark};
  font-size: 11pt;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  text-align: center;

  a {
    color: ${props => props.theme.colors.middle};
    font-weight: 600;
  }
`

const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  & > svg {
    height: 48px;
    width: auto;
  }
`

const Actions = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: calc(${props => props.theme.sizes.edge} * 1 / 2);
  padding-bottom: calc(${props => props.theme.sizes.edge} * 1);
`

function RestrictedService () {
  const id = modals.restrictedService

  return (
    <Modal id={id} title='' isCloseHidden isBackdropDisabled>
      <Content>
        <Logo>
          <AssetLogo />
        </Logo>
        <Info>
          <Section>
            <Title>
              <p>Thank you for your interest</p>
            </Title>
            <Description>
              <Paragraph>
                Interacting with the Pods application(s) is unfortunately not
                available to people or companies who are resident of, or are
                located, incorporated or have a registered agent in the United
                States. Review our Terms of Service/Use for more details.
              </Paragraph>
            </Description>
          </Section>
        </Info>
        <Actions>
          <Button
            title='Read the Terms of Service'
            appearance={a => a.gradient}
            accent={a => a.dark}
            type={t => t.external}
            to={globals.links.terms.primary.link}
            isFullWidth
          />
        </Actions>
      </Content>
    </Modal>
  )
}

export default RestrictedService
